import { render, staticRenderFns } from "./MatchProductSelectPrincipalAccordion.vue?vue&type=template&id=18f32e86&scoped=true&"
import script from "./MatchProductSelectPrincipalAccordion.vue?vue&type=script&lang=ts&"
export * from "./MatchProductSelectPrincipalAccordion.vue?vue&type=script&lang=ts&"
import style0 from "./MatchProductSelectPrincipalAccordion.vue?vue&type=style&index=0&id=18f32e86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f32e86",
  null
  
)

export default component.exports